/**
 * Procedure Categories and Procedures for MD in Dermatology, Venereology & Leprosy (DVL) students
 * Extracted with strict evidence from official NMC PDF
 */
export const DVL_MD_PROCEDURES = {
  "Diagnostic Laboratory & Cutaneous Microscopic Tests": [
    "Potassium Hydroxide (KOH) Mount Examination",
    "Gram Stain & Giemsa Stain Examination",
    "Acid-Fast Bacilli (AFB) Stain & Slit Smear / Tissue Smear",
    "Wood's Lamp Examination",
    "Dark Ground Microscopy / Illumination",
    "Bubo Aspiration",
    "Skin & Fungal Culture Media Inoculation",
  ],
  "Dermatosurgery & Aesthetic Interventions": [
    "Skin Biopsy (Punch, Excisional, Incisional) & Nail Biopsy",
    "Chemical Peeling",
    "Manual Dermabrasion",
    "Skin Punch Grafting",
    "Cryosurgery & Cryotherapy",
    "Electrocautery & Chemical Cauterization",
    "Acne Surgery (Comedone Extraction, Incision & Drainage)",
    "Nail Surgery",
    "Patch Testing & Photopatch Testing",
  ],
};

export const DVL_MD_CATEGORIES = Object.keys(DVL_MD_PROCEDURES);

export const isMDInDVLDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return (
    (d.includes("md") || d.includes("master")) &&
    (d.includes("dermatology") || d.includes("dvl") || d.includes("venereology"))
  );
};
